import { ReactNode } from 'react';

export interface CenteredPageWrapperProps {
  children?: ReactNode;
}

export const CenteredPageWrapper = ({ children }: CenteredPageWrapperProps) => {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="w-full max-w-sm">{children}</div>
    </div>
  );
};
